/** @jsx jsx */
import { jsx, Styled } from 'theme-ui';
import Link from '../link';
import UnbulletedList from '../styles/unbulleted-list';

export const Container = (props) => (
  <footer
    sx={{
      bg: 'SecondaryGray3',
      color: 'PrimaryDarkBlue',
      px: ['1.4rem', '2.8rem', '6.4rem'],
      pt: '4rem',
      pb: ['4rem', '10rem'],
      fontSize: '1.4rem',
      lineHeight: 1.43,
      display: [null, 'flex'],
      justifyContent: 'space-between',
    }}
    {...props}
  />
);

export const SinglePageBucket = (props) => (
  <UnbulletedList
    sx={{
      display: 'flex',
      mt: ['3rem', 0],
    }}
    {...props}
  />
);

export const NavLink = (props) => (
  <Link
    sx={{
      color: 'white',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
      '&:not(:last-child)': {
        borderRight: 'solid 1px white',
        pr: '2rem',
        mr: '2rem',
      },
    }}
    {...props}
  />
);

export const NavLinkAsA = (props) => (
  <Styled.a
    sx={{
      color: 'PrimaryDarkBlue',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
      '&:not(:last-child)': {
        borderRight: 'solid 1px',
        borderColor: 'PrimaryDarkBlue',
        pr: '2rem',
        mr: '2rem',
      },
    }}
    {...props}
  />
);
